import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooVsOtherAgentsPage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-vs-other-agents')!;
  return <ArticleLayout article={article} />;
}